var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isPdf)?_c('iframe',{ref:"pdfIframe",staticClass:"pdf-container",attrs:{"src":_vm.documentUrl},on:{"load":_vm.handleIframeLoad}}):_c('img',{staticClass:"image-container",attrs:{"src":_vm.documentUrl,"alt":"Image"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }